import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import AdminPage from './pages/AdminPage';

// ScrollToTop Component: Essential for a professional feel
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

function Navbar() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <nav style={{ 
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      marginBottom: '40px', padding: '20px 0', borderBottom: '1px solid rgba(255,255,255,0.05)'
    }}>
 {/* BRANDING: Single-word Brand Lockup */}
<Link to="/" style={{ textDecoration: 'none', display: 'inline-block' }}>
  <h1 style={{ 
    margin: 0, 
    fontSize: '3.2rem', 
    letterSpacing: '-3.5px', // Slightly tighter to connect the words
    color: '#ffffff',
    display: 'flex',
    alignItems: 'baseline',
    lineHeight: '0.9',
  }}>
    Hey
    <span className="shimmer-text" style={{ 
      fontWeight: '950', 
      /* Removed marginLeft to close the gap */
      filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.1))' 
    }}>
      Soham
    </span>
  </h1>
</Link>

      {/* BACK BUTTON: Styled to match your glass-morphism theme */}
      {isAdmin && (
        <Link to="/" style={{ textDecoration: 'none' }}>
          <button className="nav-btn" style={{
            position: 'static', // Override your absolute nav-btn if necessary
            padding: '10px 20px', borderRadius: '10px', cursor: 'pointer',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            color: '#94a3b8', border: '1px solid rgba(255,255,255,0.1)', fontWeight: '500',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            e.target.style.color = '#ffffff';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
            e.target.style.color = '#94a3b8';
          }}
          >
            ← View Portfolio
          </button>
        </Link>
      )}
    </nav>
  );
}

export default App;